import { APP_SAVE_BAR_SCOPE } from "@/modules/app-save-bar";

export const INTERVENTION_TEMPLATE_JSON_EDITOR_SCOPE =
  APP_SAVE_BAR_SCOPE.INTERVENTION_TEMPLATE_JSON_EDITOR;
